import { AxiosError } from 'axios';
import useSWR from 'swr';

import { WithStatusT } from '@consumer-frontend/nc-utils';

import {
  apiEndpoints,
  QueryParamsT,
} from '../lib';

type PreviewDepositResponseT = {
  disbursed_amount: number;
  draw_fee: number;
  requested_amount: number;
};

export const usePreviewDeposit = (requestedAmount?: number) => {
  const queryParams: QueryParamsT = { requested_amount: String(requestedAmount) };

  // eslint-disable-next-line @stylistic/object-curly-newline
  const { data, error, isLoading } = useSWR<WithStatusT<PreviewDepositResponseT>, AxiosError>(
    () => (requestedAmount ? apiEndpoints.dashboard.previewDeposit(queryParams) : null),
  );

  return {
    depositedAmount: data?.disbursed_amount,
    drawFee: data?.draw_fee,
    error,
    isLoading,
    requestedAmount: data?.requested_amount,
    status: data?.status || error?.status,
  };
};
